import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LoadableTeamsSubHeader: ComponentType = lazyLoadOnRender({
  loader: () => import(/* webpackChunkName: "4-feat-teamssubheader" */ './TeamsSubHeader'),
});
export default LoadableTeamsSubHeader;
